// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fRda","content":"styles_content__71m9Y","row":"styles_row__2Xs9w","footer":"styles_footer__3pUuV","phraseLength":"styles_phraseLength__YUThJ"};